import React, { useState } from 'react';
import Select from 'react-select';
import { theme } from '../theme';

const Autocomplete = ({ options, onChange, isDark = false, value = null, placeholder = 'Buscar...', isClearable = false }) => {
  const [inputValue, setInputValue] = useState('');

  const darkStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: theme.surface2,
      borderColor: state.isFocused ? theme.primary : theme.border,
      color: theme.text,
      '&:hover': {
        borderColor: state.isFocused ? theme.primary : theme.borderStrong
      }
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? theme.bg : theme.surface2,
      color: theme.text,
      cursor: 'pointer',
      '&:active': {
        backgroundColor: theme.border
      }
    }),
    singleValue: (provided) => ({
      ...provided,
      color: theme.text
    }),
    input: (provided) => ({
      ...provided,
      color: theme.text
    }),
    placeholder: (provided) => ({
      ...provided,
      color: theme.textDisabled
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: theme.surface2,
      border: `1px solid ${theme.border}`
    })
  };

  const lightStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: 'white',
      borderColor: state.isFocused ? theme.primary : 'var(--ink-border)',
      '&:hover': {
        borderColor: state.isFocused ? theme.primary : 'var(--ink-border)'
      }
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? theme.primary : 'white',
      color: state.isSelected ? 'white' : 'black',
      '&:hover': {
        backgroundColor: theme.borderSoft
      }
    })
  };

  const customStyles = isDark ? darkStyles : lightStyles;

  const handleChange = (selectedOption) => {
    onChange(selectedOption);
  };

  const handleInputChange = (inputValue) => {
    setInputValue(inputValue);
  };

  const filteredOptions = options.filter(option =>
    option.label.toLowerCase().includes(inputValue.toLowerCase())
  );

  return (
    <Select
      value={value} 
      options={filteredOptions}
      onChange={handleChange}
      onInputChange={handleInputChange}
      inputValue={inputValue}
      placeholder={placeholder}
      isClearable={isClearable}
      styles={customStyles}
      theme={themeObj => ({
        ...themeObj,
        colors: {
          ...themeObj.colors,
          primary: theme.primary
        }
      })}
    />
  );
};

export default Autocomplete;
